import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        activeMenu: '1-1',
        activeSiteId: '0',
        tableId: '',
        isTried: false,
        promoterDrawer: false,
        flowPermission1: {},
        approverDrawer: false,
        approverConfig1: {},
        copyerDrawer: false,
        copyerConfig1: {},
        conditionDrawer: false,
        conditionsConfig1: {
            conditionNodes: [],
        },
        projectId: 0
    },
    mutations: {
        changeMenuActive: (state, name) => {
            state.activeMenu = name;
        },
        changeActiveSite: (state, siteId) => {
            state.activeSiteId = siteId;
        },
        setTableId(status, payload) {
            status.tableId = payload
        },
        setIsTried(status, payload) {
            status.isTried = payload
        },
        setPromoter(status, payload) {
            status.promoterDrawer = payload
        },
        setFlowPermission(status, payload) {
            status.flowPermission1 = payload
        },
        setApprover(status, payload) {
            status.approverDrawer = payload
        },
        setApproverConfig(status, payload) {
            status.approverConfig1 = payload
        },
        setCopyer(status, payload) {
            status.copyerDrawer = payload
        },
        setCopyerConfig(status, payload) {
            status.copyerConfig1 = payload
        },
        setCondition(status, payload) {
            status.conditionDrawer = payload
        },
        setConditionsConfig(status, payload) {
            status.conditionsConfig1 = payload
        },
        setProjectId(status, projectId) {
            status.projectId = projectId;
        }
    },
    actions: {
        changeMenuActive({ commit }, name) {
            commit('changeMenuActive', name);
        },
        changeActiveSite({ commit }, siteId) {
            commit('changeActiveSite', siteId);
        },
    },
    modules: {

    },
    getters,
});

